export default function (audioPath) {
  return (audioPath || '').replace(/\.[^/.]+$/, '.aac');
}